import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: {
    isAdmin: false,
    credits: 0,
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserStatus: (state, action) => {
      state.status = {
        ...state.status,
        ...action.payload,
      };
    },
  },
});

export const { setUserStatus } = userSlice.actions;

export default userSlice.reducer;
